import { render, staticRenderFns } from "./LanguagesData.vue?vue&type=template&id=6c3123e2"
import script from "./LanguagesData.vue?vue&type=script&lang=js"
export * from "./LanguagesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports